import * as React from "react";
import AppTableCourses from "../tables/AppTableCourses";
import {
  Fab,
  Typography,
  CircularProgress,
  Alert,
  Box,
  Pagination,
  Stack,
} from "@mui/material";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import { useNavigate } from "react-router-dom";
import { CourseType } from "../../types/entitiesModel";
import { AuthContext } from "../../context/AuthContext";


function CoursesView() {
  const { token } = React.useContext(AuthContext) || {};
  const [courses, setCourses] = React.useState<CourseType[]>([]);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
  });

  const fetchCategories = async (page: number, perPage: number) => {
    setLoading(true);
    try {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await fetch(
        `/api/courses?page=${page}&per_page=${perPage}`,
        options
      );
      const data = await response.json();

      if (response.ok) {
        setCourses(data.data);
        setPagination((prev) => ({
          ...prev,
          totalPages: data.pagination.total_pages,
        }));
        setError(null);
      } else {
        setError("Error fetching users");
      }
    } catch (err) {
      setError("Error fetching users");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  React.useEffect(() => {
    fetchCategories(pagination.currentPage, pagination.perPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage, token]);

  const navigate = useNavigate();

  const handleAddUserClick = () => {
    navigate("/admin/courses/createCourse");
  };

  return (
    <>
      {!loading ? (
        <>
          <Fab
            color="primary"
            variant="extended"
            sx={{
              mr: 1,
              mb: {
                xs: 1,
                sm: 0,
                lg: 0,
              },
              ml: 2,
            }}
            onClick={handleAddUserClick}
          >
            <AddToPhotosOutlinedIcon />
            <Typography
              sx={{
                ml: 1,
                textTransform: "capitalize",
              }}
            >
              {"Añadir nuevo"}
            </Typography>
          </Fab>

          {error && (
            <Alert
              sx={{
                mx: "auto",
                my: 2,
                width: "95%",
              }}
              severity="error"
            >
              {error}
            </Alert>
          )}

          {courses.length > 0 ? (
            <Box>
              <AppTableCourses data={courses} />
              <Stack spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </Box>
          ) : (
            <Alert severity="info">No categories found.</Alert>
          )}
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}

export default CoursesView;
